import { render, staticRenderFns } from "./showItemForm.vue?vue&type=template&id=f39dbb5c&scoped=true&"
import script from "./showItemForm.vue?vue&type=script&lang=js&"
export * from "./showItemForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f39dbb5c",
  null
  
)

export default component.exports